import { IconType } from "react-icons";
import { BsShop } from "react-icons/bs";
import { BiSearch } from "react-icons/bi";
import { MdOutlineInventory2, MdTrendingUp } from "react-icons/md";

/**
 * Single source of truth for the four search-quota types.
 *
 * Every plan carries these numeric fields; this config maps each field to its
 * user-facing label, a one-line explanation, and an icon. Keeping the array
 * ordered (store → product → market → keyword) guarantees identical ordering
 * wherever quotas are rendered (Pricing cards, Billing table, Dashboard usage).
 */
export type QuotaKey =
  | "storeSearches"
  | "listingSearches"
  | "marketSearches"
  | "keywordsSearches";

export interface QuotaTypeMeta {
  key: QuotaKey;
  label: string;
  description: string;
  Icon: IconType;
}

export const QUOTA_TYPES: QuotaTypeMeta[] = [
  {
    key: "storeSearches",
    label: "Store Discovery",
    description: "Look up & analyze competitor and seller store profiles.",
    Icon: BsShop,
  },
  {
    key: "listingSearches",
    label: "Product Discovery",
    description: "Search products and view sales data & trends.",
    Icon: MdOutlineInventory2,
  },
  {
    key: "marketSearches",
    label: "Market Research",
    description: "Analyze trending niches and market demand.",
    Icon: MdTrendingUp,
  },
  {
    key: "keywordsSearches",
    label: "Keyword Research",
    description: "See search-volume and keyword demand metrics.",
    Icon: BiSearch,
  },
];
